import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { AnalyticsIcon } from 'components/Atoms/Icon';

const Analytics = lazy(() => import('components/Pages/Analytics'));
const AnalyticDetail = lazy(() => import('components/Pages/AnalyticDetail'));

export const analyticRoutes = [
  {
    path: routePath.ANALYTICS,
    component: Analytics,
    exact: true,
    name: routeName.ANALYTICS,
    parentName: routeName.ANALYTICS,
    icon: AnalyticsIcon,
    showMenu: true,
  },
  {
    path: routePath.ANALYTIC_DETAIL,
    component: AnalyticDetail,
    exact: true,
    parentName: routeName.ANALYTICS,
    breadcrumbs: [{ name: routeName.ANALYTICS, link: routePath.ANALYTICS }],
  },
];
